var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"helpSec"},[_c('div',[_c('HelpSidebar',{attrs:{"propsSidebar":_vm.sidebar,"propsFirstContentNum":_vm.firstNumInfo},on:{"onChangeNum":_vm.changeNum}})],1),_c('div',[_c('HelpText',{attrs:{"propsHelpContent":_vm.helpContent}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }